import { render } from "./NotesModal.vue?vue&type=template&id=1f91a976&scoped=true"
import script from "./NotesModal.vue?vue&type=script&lang=js"
export * from "./NotesModal.vue?vue&type=script&lang=js"

import "./NotesModal.vue?vue&type=style&index=0&id=1f91a976&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f91a976"]])

export default __exports__